import { useQuery } from '@tanstack/react-query';
import { strapiListAllTestResults } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useTestResultsListQuery(jwt: string | null, queryEnabled = true) {
  return useQuery({
    queryKey: queryKeys.testResultsFlat(jwt),
    queryFn: () => strapiListAllTestResults(jwt!),
    enabled: Boolean(jwt) && queryEnabled,
  });
}
